var mAppLauncher = "";
export function setLauncher(agency) {
    if(agency == "android_app_v1") {
        mAppLauncher = "android";
    } else if(agency == "ios_app_v1") {
        mAppLauncher = "ios";
    } else {
        mAppLauncher = "web";
    }
}
export function getLauncher() {
    return mAppLauncher;
}